import React from "react";

const Stat_Making_Conclusions = () => {
  return (
    <div>
      <h1>Stat Making Conclusions</h1>
    </div>
  );
};

export default Stat_Making_Conclusions;
